module.exports = __webpack_public_path__ + "static/media/Milotic_gaussian2.45d823c4.png";